(function() {
  'use strict';
  angular.module('benefits')
    .component('providerInfo', {
      bindings: {
        provider: '='
      },
      controller: ['phoneFilter', function providerInfoController(phoneFilter) {
        var ctrl = this;

        ctrl.$onInit = setDisplayValues;
        ctrl.$onChanges = setDisplayValues;

        function setDisplayValues() {
          var provider = ctrl.provider || {};

          ctrl.centerName = getTextValue(provider.name, 'No Assigned Center');
          ctrl.centerNumber = getTextValue(provider.id, 'No Assigned Center');
          ctrl.centerPhone = formatPhoneNumber(provider.phone);
        }

        function getTextValue(value, emptyValue) {
          if (value === null || value === undefined) {
            return emptyValue;
          }

          value = value.toString().trim();
          return value ? value : emptyValue;
        }

        function formatPhoneNumber(value) {
          value = getTextValue(value, '');
          return value ? phoneFilter(value) : '';
        }
      }],
      templateUrl: '/js/benefits/providerInfo.html' + appVersion
    });
})();
